<template>
  <!-- 5-4 教育机关视角下 查看医疗机关主页 -->
  <div class="main-css">
    <div class="main-box-css-all">
      <div class="main-box">
        <!-- 左边查看信息部分 -->
        <div class="left-box">
          <!-- 主要显示box 滚动条隐藏部分 -->
          <div class="left-main-box">
            <!-- 第一行 -->
            <div class="one-line-box">
              <div class="avt-img">
                <img
                  :src="avatarAddressUrl"
                  alt=""
                  @error="
                    e => {
                      e.target.src = require('@/assets/defaultImg.png');
                    }
                  "
                />
              </div>
              <div class="big-form-box">
                <span>{{ $t("institutionName") }}</span>
                <el-tooltip
                  :content="medicalInstitution.medicalName"
                  placement="top"
                >
                  <p class="institution-main ">
                    {{ medicalInstitution.medicalName+'1212' }}
                  </p></el-tooltip
                >

                <!-- 认证部分 -->
                <div class="certified">{{ $t("certified") }}</div>
              </div>
            </div>
            <!-- 第二行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("postCode") }}</span>
                <p class="small-box-title">
                  {{ medicalInstitution.postNumber }}
                </p>
              </div>
              <div class="big-box">
                <span>{{ $t("location") }}</span>
                <el-tooltip
                  :content="medicalInstitution.address"
                  placement="top"
                >
                  <p class="small-box-title">
                    {{ medicalInstitution.address }}
                  </p></el-tooltip
                >
              </div>
            </div>
            <!-- 第三行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("institutionalAttributes") }}</span>
                <el-tooltip :content="attributes" placement="top">
                  <p class="small-box-title">
                    {{ attributes }}
                  </p></el-tooltip
                >
              </div>
              <div class="big-box">
                <span>{{ $t("hpOrSns") }}</span>
                <el-tooltip
                  :content="medicalInstitution.hpOrSns"
                  placement="top"
                >
                  <p class="small-box-title">
                    {{ medicalInstitution.hpOrSns }}
                  </p></el-tooltip
                >
              </div>
            </div>
            <!-- 第四行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("representativeName") }}</span>
                <el-tooltip
                  :content="medicalInstitution.legalPerson"
                  placement="top"
                >
                  <p class="small-box-title">
                    {{ medicalInstitution.legalPerson }}
                  </p></el-tooltip
                >
              </div>
              <div class="big-box">
                <span>{{ $t("institutionalNumber") }}</span>
                <p class="small-box-title">
                  {{ medicalInstitution.telephone }}
                </p>
              </div>
            </div>
            <!-- 第五行 -->
            <div class="other-line-box">
              <div class="small-box">
                <span>{{ $t("registeredCapital") }}</span>
                <p class="small-box-title">{{ capitalAmount }}</p>
              </div>
              <div class="most-small-box" style="margin-right: 12px">
                <span>{{ $t("numberStaff") }}</span>
                <p class="small-box-title">{{ employeeNumber }}</p>
              </div>
              <div class="most-small-box">
                <span>{{ $t("numberOfBets") }}</span>
                <p class="small-box-title">{{ bedNumber }}</p>
              </div>
            </div>
            <!-- 第六行 -->
            <div class="textarea-line-box">
              <div class="textarea-box">
                <span>{{ $t("businessContent") }}</span>
                <el-tooltip
                  :content="medicalInstitution.introduction"
                  placement="top"
                >
                  <p class="textarea-css-main">
                    {{ medicalInstitution.introduction }}
                  </p></el-tooltip
                >
              </div>
            </div>
            <!-- table 部分 -->
            <div class="table-line">
              <el-table
                :data="tableData"
                style="width: 100%"
                height="450"
                @row-click="jump"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column
                  prop="jobName"
                  label="案件名"
                  width="200"
                  :show-overflow-tooltip="true"
                >
                  <template slot="header">
                    <p>{{ $t("caseName") }}</p>
                    <el-input
                      v-model="tableSearch1"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.jobName }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="workSpace"
                  label="勤務地"
                  width="100"
                  :show-overflow-tooltip="true"
                >
                  <template slot="header">
                    <p>{{ $t("workLocation") }}</p>
                    <el-input
                      v-model="tableSearch2"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.workSpace }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="endTime"
                  label="掲載日"
                  :show-overflow-tooltip="true"
                >
                  <template slot="header">
                    <p>{{ $t("payonTheDay") }}</p>
                    <el-input
                      v-model="tableSearch3"
                      size="mini"
                      placeholder="Search"
                    />
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.createTime }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="visitedTime"
                  label="観覧回数"
                  :sortable="'custom'"
                  :show-overflow-tooltip="true"
                >
                  <template slot="header">
                    <p class="empty-ps">{{ $t("numberOfVisits") }}</p>

                    <p class="empty"></p>
                  </template>
                  <template slot-scope="scope">
                    {{ scope.row.visitedTime }}
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页部分 -->
              <div class="pagination">
                <div class="el-pagination">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    layout=" prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    small
                  >
                  </el-pagination>
                </div>
                <div class="rowsPage">
                  <span>Rows per page</span>
                  <div class="rowsPage-css">
                    <el-dropdown @command="handleCommand">
                      <span class="el-dropdown-link">
                        {{ pageSize
                        }}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="a">7</el-dropdown-item>
                        <el-dropdown-item command="b">15</el-dropdown-item>
                        <el-dropdown-item command="c">20</el-dropdown-item>
                        <el-dropdown-item command="d">25</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 右边聊天部分 -->
        <div class="right-box">
          <Socket></Socket>
        </div>
      </div>
      <!-- button 部分 -->
      <div class="main-button">
        <button @click="collect">{{ $t("collection") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import Socket from "../../components/socket.vue";
import {
  queryMedicalInstitutionInfo,
  medicalInstitutionListQuery,
  queryMedicalInstitutionDetailInfo,
  recruitmentInformationDetails,
  medicalInstitutionDetailsQuery,
  educationalInstitutionDisplay,
  medicalResumeDetailInfo,
  getUrlFromOSS,
  addEducationCollect
} from "../../js/api";
import AES from "../../js/AES";
export default {
  name: "educationViewMedicalHomepage",
  components: { Socket },
  data() {
    return {
      //列表数据
      tableData: [
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "570" //観覧回数
        }
      ],
      tableSize: 5,
      total: 50,
      institutionName: "", //機関名
      postCode: "", //郵便番号
      area: "", //所在地
      agencyAttribute: "", //機関属性
      hPorSNS: "", //HP or SNS
      representativeName: "", //代表者氏名
      phoneNumber: "", //機関の電話番号
      numberEmployees: "", //授業員数
      numberBets: "", //ベット数
      capital: "", //資本金
      textData: "", //事业内容
      frequency: "", //職員数
      avatarAddressUrl: "", //头像回显
      projectTitleSearch: "", //案件名搜索框
      workLocationSearch: "", //勤務地搜索框
      publicationDateSearch: "", //掲載日搜索框
      loading: false,
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      medicalInstitution: [],
      tableSearch1: "", //案件名
      tableSearch2: "", //勤務地
      tableSearch3: "", //掲載日
      attributes: "",
      capitalAmount: "",
      bedNumber: "",
      language: "",
      medicalId: "",
      employeeNumber: ""
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    //获取数据字典语言值方法
    this.getLanguage();
    console.log(
      "首页id" + this.$route.params.ResumeId,
      this.$route.query.medicalId
    );
    this.medicalId =
      this.$route.params.medicalId || this.$route.query.medicalId;
    console.log("医疗机构id" + this.medicalId);
    this.getMedicalInstitutionDetailsQuery(this.medicalId);
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //qaq
    languageChange(e) {
      const that = this;
      console.log("------监听数据1------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        that.getLanguage();
        that.medicalId = that.$route.params.medicalId;
        this.getMedicalInstitutionDetailsQuery(that.medicalId);
      }
    },
    jump(row) {
      console.log(row, "rowrowrow");
      this.$router.push({
        path: "/educationViewJobInformation",
        query: { id: row.jobId }
      });
    },
    //添加收藏
    collect() {
      console.log(this.$route.params.id);
      var educationCollectAddDTO = {
        systemEventId: this.medicalId,
        systemTypeId: 0
      };
      addEducationCollect(educationCollectAddDTO)
        .then(res => {
          if (res.data.code === "A0000") {
            console.log(res);
            this.$message({
              message: "恭喜你，收藏成功",
              type: "success"
            });
            this.$router.push(
              "/educationalInstitutionCollectionMedicalInstitutionList"
            );
          } else if (res.data.code === "A0506") {
            this.$message.error(this.$t("已收藏请勿重复操作"));
          } else {
            console.log(res);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getLanguage() {
      console.log("语言" + this.language);
      if (this.language === "CN") {
        this.capitalAmount = this.medicalInstitution.capitalAmount_dictText;
        this.attributes = this.medicalInstitution.attributes_dictText;
        this.bedNumber = this.medicalInstitution.bedNumber_dictText;
        this.employeeNumber = this.medicalInstitution.employeeNumber_dictText;
      } else {
        this.capitalAmount = this.medicalInstitution.jpcapitalAmount_dictText;
        this.attributes = this.medicalInstitution.jpattributes_dictText;
        this.bedNumber = this.medicalInstitution.jpbedNumber_dictText;
        this.employeeNumber = this.medicalInstitution.jpemployeeNumber_dictText;
      }
    },
    //接口 获取表格数据
    //医疗机构信息查询(详情) //id未传
    getMedicalInstitutionDetailsQuery(medicalId) {
      var fecInfo = {
        medicalId: medicalId,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };

      medicalInstitutionDetailsQuery(fecInfo)
        .then(res => {
          console.log("--------医疗机构信息查询(详情)接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.medicalInstitution = aesFecInfo.data1[0];
            this.getLanguage();
            console.log(this.medicalInstitution);
            this.tableData = aesFecInfo.data2;
            this.total = this.tableData.length;
            console.log(this.tableData);
            //头像回显
            var fakeInfo = {
              message: this.medicalInstitution.avatarAddress
            };
            getUrlFromOSS(fakeInfo)
              .then(res => {
                console.log("-----------头像回显11111-----------");
                if (res.data.code === "200 OK") {
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
                  console.log(aesFecInfo);
                  this.avatarAddressUrl = aesFecInfo.message;
                }
                console.log(res);
              })
              .catch(res => {
                console.log("-----------头像回显-----------");
                console.log(res);
              });
          }
        })
        .catch(res => {
          console.log("医疗机构信息查询(详情)接口数据异常:", res);
        });
    },
    change(e) {
      this.$forceUpdate();
    },
    //表格排序
    changeTableSort(custom) {
      console.log(custom);
      if (custom.order === "ascending") {
        this.tableData = this.tableData.sort(
          (a, b) => a["numberViewing"] - b["numberViewing"]
        );
      } else if (custom.order === "descending") {
        this.tableData = this.tableData.sort(
          (a, b) => b["numberViewing"] - a["numberViewing"]
        );
      }
    },
    // 案件名search
    handleProjectTitleSearch() {
      console.log("案件名search");
      console.log(this.projectTitleSearch);
    },
    // 勤務地search
    handleWorkLocationSearch() {
      console.log("勤務地search");
      console.log(this.workLocationSearch);
    },
    // 掲載日search
    handlePublicationDateSearch() {
      console.log("掲載日search");
      console.log(this.publicationDateSearch);
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
      this.getMedicalInstitutionDetailsQuery(this.medicalId);
    },
    // 分页页数变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMedicalInstitutionDetailsQuery(this.medicalId);
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
}
.main-box {
  /* min-width: 1100px; */
  margin: 0 auto;
  flex: 1;
  padding-top: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  overflow: hidden;
}
.main-box-css-all {
  /* min-width: 1100px; */
  margin: 0 auto;
}

.left-box {
  width: 550px;
  height: 700px;
  float: left;
  overflow: hidden;
  padding-bottom: 20px;
}
.left-main-box {
  /* width: 700px;
    padding-right: 18px; */
  height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.left-main-box::-webkit-scrollbar {
  width: 0;
}
.main-left-box {
  width: 700px;
  padding-right: 18px;
  height: 600px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.one-line-box {
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
}
.avt-img {
  width: 160px;
  height: 160px;
  overflow: hidden;
  border-radius: 50%;
}
.big-form-box {
  height: 57px;
  width: 299px;
  border-radius: 8px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  margin-left: 30px;
  margin-top: 50px;
  position: relative;
}
.certified {
  width: 49px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  letter-spacing: -0.02em;
  color: #ffffff;
  position: absolute;
  right: 0;
  top: -22px;
}
.big-form-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.other-line-box {
  width: 100%;
  height: 45px;
  margin-top: 24px;
  display: flex;
}
.small-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 10px;
}
.small-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.big-box {
  width: 292px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.big-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.most-small-box {
  width: 140px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.most-small-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.textarea-line-box {
  width: 100%;
  height: 180px;
  margin-top: 24px;
  display: flex;
}
.textarea-box {
  width: 500px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.textarea-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.table-line {
  margin-top: 24px;
  width: 500px;
  height: 450px;
}
.table-line /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
}
.number-viewing {
  position: relative;
}
.table-line /deep/ .caret-wrapper {
  position: absolute;
  top: -4px;
  right: 0;
}
.table-line .empty {
  height: 30px;
}
.right-box {
  background: #fff;
  width: 460px;
  height: 650px;
  margin-top: 40px;
}

.main-button {
  /* width: 500px; */
  height: 50px;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 80px;
}
.main-button button {
  cursor: pointer;
  height: 40px;
  width: 152px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}

.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
  display: flex;
  justify-content: right;
}
.rowsPage {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  display: inline-block;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.institution-main {
  margin-top: 15px;
  padding: 0 20px;
  box-sizing: border-box;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #686868;
  overflow: hidden;

white-space: nowrap;

text-overflow: ellipsis;

-o-text-overflow: ellipsis;

}
.small-box-title {
  margin-top: 12px;
  padding-left: 20px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;

  white-space: nowrap;

  text-overflow: ellipsis;

  -o-text-overflow: ellipsis;
}
.textarea-css-main {
  width: 99%;
  height: 99%;
  margin-left: 1px;
  margin-top: 1px;
  border-radius: 8px;
  padding: 15px 5px 5px 20px;
  box-sizing: border-box;
}
.avatar {
  width: 150px;
  height: 150px;
  border-radius: 50%;
}
.avatar img {
  width: 150px;
  height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationViewMedicalHomepage/index.vue